import { Injectable } from '@angular/core';
import { from, Observable, switchMap, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LocationService {
  getUserLocation$(): Observable<GeolocationPosition> {
    if (!navigator.geolocation) {
      return throwError(() => ({ error: 'unsupported' }));
    }

    // First check permission state using Permissions API
    return from(navigator.permissions.query({ name: 'geolocation' as PermissionName })).pipe(
      switchMap((status) => {
        if (status.state === 'denied') {
          return throwError(() => ({ error: 'blocked' }));
        }

        return new Observable<GeolocationPosition>((observer) => {
          navigator.geolocation.getCurrentPosition(
            (pos) => {
              observer.next(pos);
              observer.complete();
            },
            (err) => {
              if (err.code === err.PERMISSION_DENIED) {
                observer.error({ error: 'blocked' });
              } else {
                observer.error({ error: 'failed' });
              }
            },
            { enableHighAccuracy: true, timeout: 8000 }
          );
        });
      })
    );
  }
}
